'use strict'

export default {
  computed: {
    store () {
      return this.$store.state.process.batPersonalAccount
    },

    storeResponse () {
      return this.store.response
    },

    storeResponseSingle () {
      return this.storeResponse ? this.storeResponse.single : null
    },

    storeResponseSingleData () {
      return this.storeResponseSingle ? this.storeResponseSingle.data : null
    },

    storeResponseSingleDataProcess () {
      return this.storeResponseSingleData ? this.storeResponseSingleData['bat-personal-account'] : null
    }
  }
}
